/*
 * Filters out digital assistant page options based on user type and permissions.  To restrict an option based on
 * permission strings, add a requiredPermission key to the option in translations.json.  To restrict an option based on
 * user type, add the permitted users to an allowedUsers key in translations.json.
 */
export const getPermittedOptions = (options, userPermissions, userType) =>
    options.filter(option => !option.requiredPermission || userPermissions.includes(option.requiredPermission))
           .filter(option => !option.allowedUsers || option.allowedUsers.includes(userType))


// WEBPACK FOOTER //
// ./src/mi-app/digitalAssistant/BotAssistantUtils.js